module.exports = {"511304001":"火花街道","511304003":"都尉街道","511304004":"文峰街道","511304005":"西兴街道","511304006":"南湖街道","511304101":"曲水镇","511304102":"李渡镇","511304103":"吉安镇","511304104":"龙岭镇","511304105":"金凤镇","511304106":"安福镇","511304107":"安平镇","511304108":"世阳镇","511304109":"大通镇","511304110":"一立镇","511304111":"龙蟠镇","511304112":"里坝镇","511304114":"金宝镇","511304115":"三会镇","511304117":"双桂镇","511304119":"七宝寺镇","511304121":"河西镇","511304215":"盐溪乡","511304220":"大兴乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511304.json
// module id = 2473
// module chunks = 0